import Auction from "./AuctionContainer";

export default Auction;
